import React, { FC } from 'react';
import SportOverviewContext from '../context/SportOverviewContext';

const SportProvider: FC<{ sportName: string }> = ({ sportName, children }) => {
    return <SportOverviewContext.Provider value={sportName}>{children}</SportOverviewContext.Provider>;
};

export default SportProvider;
